import { render, staticRenderFns } from "./QaS.vue?vue&type=template&id=b96305be&"
import script from "./QaS.vue?vue&type=script&lang=js&"
export * from "./QaS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports